import { render } from "./product-request-item-update.vue?vue&type=template&id=75cd9d5a"
import script from "./product-request-item-update.vue?vue&type=script&lang=js"
export * from "./product-request-item-update.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__